import router from "@/router"

import {
  DECREMENT_SUPPORT_TICKETS_COUNT,
  HANDLE_SUPPORT_DRAWER,
  SET_SUPPORT_TICKETS_COUNT
} from "./mutationTypes"

const state = () => ({
  newSupportTicketsCount: 0,
  isTopUpButtonTriggered: false,
  drawerSubject: "",
  drawerText: ""
})

const mutations = {
  [SET_SUPPORT_TICKETS_COUNT](state, count) {
    state.newSupportTicketsCount = count
  },

  [DECREMENT_SUPPORT_TICKETS_COUNT](state) {
    const decrementedCount = state.newSupportTicketsCount - 1

    state.newSupportTicketsCount = Math.max(decrementedCount, 0)
  },
  // Трігер відкриття заявки вільної форми,
  // isTopUpButtonTriggered дає зрозуміти компоненту технічної підтримки, що потрібно відкрити вікно оформлення заявки
  // Після відкриття заявки в компоненті тех підтримки знову викликається ця мутація, де open === false || undefined для того,
  // аби isTopUpButtonTriggered змінився лише після завантаження сторінки тех підтримки і спрацювання функції відкриття
  async [HANDLE_SUPPORT_DRAWER](state, { subject, text, open }) {
    state.drawerSubject = subject || ""
    state.drawerText = text || ""

    if (open) {
      if (router.history.current.name !== "support") {
        router.push({
          name: "support",
          query: { page: 1 }
        })
      }

      state.isTopUpButtonTriggered = true
    } else {
      state.isTopUpButtonTriggered = false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
